module.exports = __webpack_public_path__ + "img/sec14desk.853352ac.png";